import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';

// Services
import { PaymentsService } from 'src/app/modules/payments/payments.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { UiService } from 'src/app/platform/services/ui.service';

@Component({
  selector: 'app-payments-report',
  templateUrl: './payments-report.component.html',
  styleUrls: ['./payments-report.component.scss']
})
export class PaymentsReportComponent implements OnInit {
  public formData: FormGroup = new FormGroup({
    date: new FormControl('', [Validators.required]),
  });

  constructor(
    public dialog: MatDialogRef<PaymentsReportComponent>,
    private uiService: UiService,
    private platformService: PlatformService,
    private paymentsService: PaymentsService,
  ) { }

  ngOnInit(): void { }

  onCancel(): void {
    this.dialog.close();
  }

  onSubmit(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.paymentsService.paymentReport(this.formData.get('date')?.value).then((result) => {
        if (result.status) {
          this.dialog.close();

          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Reportar pago', 'Tu pago fue reportado correctamente. Tu número de gestión es: <p><center><h1>' + result.result.id + '</h1></center></p>', 'success');
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Reportar pago', result.message, 'alert');
        }
      }, (error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible reportar un pago en este momento. Estamos trabajando para solucionar el inconveniente.');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      date: {
        required:  'Ingresá la fecha de pago'
      },
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }
}
